<template>
  <ModalMask :inline="inline">
    <div class="loading-message">
      <LoadingIndicator class="loading" />
      <p>{{ message }}</p>
    </div>
  </ModalMask>
</template>

<script>
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import ModalMask from '@/components/molecules/ModalMask'

export default {
  name: 'LoadingMessage',
  components: {
    LoadingIndicator,
    ModalMask,
  },
  props: {
    /** メッセージ */
    message: { type: String, default: 'ロード中…' },
    /**
     * インライン表示（スタイルガイド用）
     * @ignore
     */
    inline: { type: Boolean, default: false },
  },
}
</script>

<style lang="postcss" scoped>
.loading-message {
  align-content: center;
  background: var(--white);
  box-sizing: border-box;
  display: grid;
  font-size: 21px;
  grid-gap: 16px;
  justify-content: center;
  min-height: 240px;
  padding: 32px;
  position: relative;
  width: 480px;

  > .loading {
    position: static;
  }
}
</style>
